import React from "react"

import styled from "styled-components/native"

import { colorWithAlpha } from "@treefort/lib/color"
import rawTokens from "@treefort/tokens/app"
import icons from "@treefort/tokens/app/icons"

import Icon from "./icon"

const LockBox = styled.View`
  position: absolute;
  bottom: 6px;
  right: 6px;
  background-color: ${({ theme }) => colorWithAlpha(theme.colors.black, 0.4)};
  border-radius: ${({ theme }) => theme.borderRadius.roundedFull}px;
  padding: 5px;
`

export default function LockedContentIndicator(): React.JSX.Element {
  return (
    <LockBox>
      <Icon source={icons.lock} size="small" color={rawTokens.colors.white} />
    </LockBox>
  )
}
